import { render } from "./PartnerHeader.vue?vue&type=template&id=13c3591c&scoped=true"
import script from "./PartnerHeader.vue?vue&type=script&lang=js"
export * from "./PartnerHeader.vue?vue&type=script&lang=js"

import "./PartnerHeader.vue?vue&type=style&index=0&id=13c3591c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c3591c"]])

export default __exports__